import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
// config
import configData from "../../../config/config.json";
// components
import AlertSuccess from "../../AlertSuccess/AlertSuccess";
import AlertError from "../../AlertError/AlertError";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const InformationStep2 = () => {
  const [disable, setDisable] = useState(false);
  const [dataCome, setdataCome] = useState(false);

  // radio btns
  const [value, setValue] = useState(null);
  // owner name part
  const [owner, setOwner] = useState(false);
  const handleChange = (event) => {
    setValue(event.target.value);
    if (event.target.value === "1") {
      setOwner(true);
    } else {
      setOwner(false);
    }
  };

  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 3000);
  };

  const [errorAlert, setErrorAlert] = useState(null);
  const errorAlertHandeler = (lang) => {
    setErrorAlert(lang);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setErrorAlert(null);
    }, 4000);
  };

  const inputHandler = (e) => {
    setOtherValue(e.target.value.replace(/[^A-Za-z0-9\s,]/gi, ""));
    // Validate input to allow only English characters, numbers, and spaces
    if (!/^[a-zA-Z0-9 ]*$/.test(e.target.value)) {
      errorAlertHandeler("انگلیسی");
    }
  };

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  const [otherValue, setOtherValue] = useState("");

  useEffect(() => {
    setdataCome(false);

    axios
      .get(
        configData.API_DOMAIN + `/api/v1/Businesses/${getCookie("BizUuid")}`,
        {
          headers: header,
        }
      )
      .then((response) => {
        if (response.data.isSuccess) {
          let data = response.data.data;
          setdataCome(true);
          setValue(data.ownerType);
          setOtherValue(data.ownerFullName);
          // if (
          //   data.ownerType == "1" || data.ownerFullName !== "") {
          //   setOwner(true);
          // }
        }
      })
      .catch((error) => {
        // alert(error);
      });
  }, []);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const submitHandler = (event) => {
    event.preventDefault();
    setDisable(true);

    const dataPost = {
      // OwnerType: parseInt(value),
      // Fullname: value == "1" ? otherValue : "",

      bId: getCookie("BizId"),
      ownerType: parseInt(value),
      fullName: otherValue,
    };

    axios
      .patch(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/owner`,
        dataPost,
        {
          headers: header,
        }
      )
      .then((response) => {
        setDisable(false);
        if (response.data.isSuccess) {
          // success
          alertHandeler();
        }
      })
      .catch((error) => {
        // alert(error);
      });
  };

  return (
    <>
      <div className="part_tow_info">
        {dataCome ? (
          <div dir="rtl" className="step2_radio">
            <CacheProvider value={cacheRtl}>
              <ThemeProvider theme={theme}>
                <div
                  id=""
                  className="me-md-0 width-sm-100 w-90-bus-dash  position-relative"
                >
                  <p className="rb-step1-text">اختیاری</p>

                  <div className="mt-12px mb-4">
                    <TextField
                      value={otherValue}
                      onChange={inputHandler}
                      type="text"
                      id="outlined-basic"
                      label="نام مالک کسب‌و‌کار"
                      variant="outlined"
                      className={
                        "label-field-more5 custom-text-field width100 width-100 mb-0 mt-3"
                      }
                    />
                  </div>
                </div>
              </ThemeProvider>
            </CacheProvider>

            <label className="container-rbtn-s1 " onChange={handleChange}>
              <input
                type="radio"
                name="radio"
                value="1"
                checked={value == "1"}
              />
              <span className="checkmark_step2_info"></span>
              <span>مالک این کسب‌و‌کار فارسی زبان است</span>
            </label>
            {/* {owner ? (
              <CacheProvider value={cacheRtl}>
                <ThemeProvider theme={theme}>
                  <div
                    id=""
                    className="me-md-0 width-sm-100 w-90-bus-dash  position-relative"
                  >
                    <p className="rb-step1-text">اختیاری</p>

                    <div className="mt-12px mb-4">
                      <TextField
                        value={otherValue}
                        onChange={inputHandler}
                        type="text"
                        id="outlined-basic"
                        label="نام مالک کسب‌و‌کار"
                        variant="outlined"
                        className={
                          "label-field-more5 custom-text-field width100 width-100 mb-0 mt-3"
                        }
                      />
                    </div>
                  </div>
                </ThemeProvider>
              </CacheProvider>
            ) : (
              ""
            )} */}
            <label
              className="container-rbtn-s1 d-flex align-items-stretch align-items-md-center"
              onChange={handleChange}
            >
              <input
                type="radio"
                name="radio"
                value="2"
                checked={value == "2"}
              />
              <span className="checkmark-responsive checkmark_step2_info "></span>
              مالک این کسب‌و‌کار فارسی زبان نیست اما بعضی از کارکنان به زبان
              فارسی صحبت می‌کنند
            </label>
            {/* <label className="container-rbtn-s1" onChange={handleChange}>
              <input
                type="radio"
                name="radio"
                value="3"
                checked={value == "3"}
              />
              <span className="checkmark_step2_info"></span>
              من مشتری این کسب‌و‌کار هستم
            </label> */}
          </div>
        ) : (
          <>
            <Skeleton
              className="radius2 mt-2 mb-4"
              variant="rectangular"
              height={30}
              animation="wave"
            />
            <div className="d-flex justify-content-right mt-1 mb-2">
              <Skeleton
                className=""
                variant="circular"
                width={17}
                height={16}
                animation="wave"
              />
              <Skeleton
                className="w-100 me-3"
                // variant="rectangular"
                // width={123}
                // height={5}
                variant="text"
                sx={{ fontSize: "0.5rem" }}
                animation="wave"
              />
            </div>
            <div className="d-flex justify-content-right mt-1 mb-2">
              <Skeleton
                className=""
                variant="circular"
                width={17}
                height={16}
                animation="wave"
              />
              <Skeleton
                className="w-100 me-3"
                // variant="rectangular"
                // width={123}
                // height={5}
                variant="text"
                sx={{ fontSize: "0.5rem" }}
                animation="wave"
              />
            </div>{" "}
            {/* <div className="d-flex justify-content-right mt-1 mb-2">
              <Skeleton
                className=""
                variant="circular"
                width={17}
                height={16}
                animation="wave"
              />
              <Skeleton
                className="w-100 me-3"
                // variant="rectangular"
                // width={123}
                // height={5}
                variant="text"
                sx={{ fontSize: "0.5rem" }}
                animation="wave"
              />
            </div> */}
          </>
        )}
        <div className="step2_save_c">
          {dataCome ? (
            <button
              onClick={submitHandler}
              disabled={disable}
              className="btn_information_submit"
            >
              ذخیره اطلاعات
            </button>
          ) : (
            <Skeleton
              className="btn_information_submit me-auto"
              variant="rectangular"
              height={39}
              animation="wave"
            />
          )}
        </div>
        {/* alert delete */}
        <AlertSuccess
          showAlert={showAlert}
          text={" اطلاعات شما با موفقیت ثبت شد."}
        />
      </div>
      {/* alert error */}
      <AlertError
        showAlert={errorAlert}
        text={`زبان کیبورد را به ${errorAlert} تغییر دهید.`}
      />
    </>
  );
};

export default InformationStep2;
